import { cloneDeep } from "lodash";
import CryptoJS from 'crypto-js';
import { FIELD_TYPE, RECORD_TYPE } from "../constants/datatypes";
import axios from "axios";
import { deepClone } from "lodash";
import {eachDeep} from 'deepdash-es/standalone';
import { getSelectedNodes } from "../components/RightContextMenu/ContextActions/CopyAndPaste";
import { t } from "i18next";

export default function hexToAscii(str) {
  let h = str.toString();
  let output = '';
  for (let n = 0; n < h.length; n += 2) {
    output += String.fromCharCode(parseInt(h.substr(n, 2), 16));
  }
  return output;
}

//Using this because Math.random is not guaranteed to be "random" in large scale 
export function genKey(inputStr, maxLength) {
  // remove nonword from inputStr, add to mathrandom * date. split string by char, 
  // and sort, then join by char. substr at end to limit max length
  return ((inputStr || 'noinput').replace(/[\W_]/g, '').split(' ').join('') + (Math.floor(Math.random() * Date.now())))
    .split('').sort(() => 0.5 - Math.random()).join('').substring(0, maxLength || 16);
}

// export const memoize = (fn) => {
//   let cache = {};
//   return (...args) => {
//     let n = args[0];
//     if (n in cache) {
//       console.log('Fetching from cache');
//       return cache[n];
//     }
//     else {
//       console.log('Calculating result');
//       let result = fn(n);
//       cache[n] = result;
//       return result;
//     }
//   }
// }


// Function will iterate nested tree node and assign nodeId to each node.
export const nestedNodeIdAssign = (node) => {
  const tempNode = deepClone(node);
  tempNode['nodeId'] = genKey(node?.title);
  const loopChildren = (data) => {
    data?.forEach(ele => {
      ele['nodeId'] = genKey(ele?.title);
      if (ele?.children?.length) loopChildren(ele?.children)
    })
  }
  if (tempNode?.children?.length) loopChildren(tempNode?.children)
  return tempNode;
}


export const memoize = (func) => {
  const results = {};
  return (...args) => {
    const argsKey = JSON.stringify(args);
    if (!results[argsKey]) {
      results[argsKey] = func(...args);
    }
    return results[argsKey];
  };
};


// this function takes selectedkeys array and parent div ref (useRef) and then scroll to selected node.
// Note:- Before calling this function pass key into your node element as data-key attribute 
// Note:- Parent Ref should be of that element which needs to scroll
export const scrollToSelectedItem = (selectedKeys, ref) => {
  if (selectedKeys.length > 0 && ref.current) {
    const parentDiv = ref.current;
    const childDiv = parentDiv?.querySelector(`[data-key="${selectedKeys?.[0]}"]`);
    const parentRect = parentDiv?.getBoundingClientRect();
    const childRect = childDiv?.getBoundingClientRect();
    // Calculate the relative positions of the child inside the parent
    const relativeTop = childRect?.top - parentRect?.top;
    // Calculate the relative positions of the child bottom 
    const relativeBottom = relativeTop + childRect?.height;
    // Check if the child is fully within the visible area of the parent
    const isFullyVisible = relativeTop >= 0 && relativeBottom <= parentRect?.height;
    // If the child is not fully visible, scroll the parent to make it visible
    if (!isFullyVisible) {
      // Calculate the new scroll positions to center the child inside the parent
      const newScrollTop = parentDiv?.scrollTop + relativeTop - (parentRect?.height - childRect?.height) / 2;
      // Set the scroll position for the parent element
      parentDiv?.scroll({
        top: newScrollTop,
        left: 0,
        behaviour: 'smooth'
      })
    }

  }
}

export const findParentLoopNodes = (translatedData, nodeKey) => {
  if (!translatedData || !nodeKey || nodeKey === 'wf-0') {
    return [];
  }

  const parentLoops = [];
  const keyParts = nodeKey.split('-');
  
  // Remove the 'wf' prefix and current node index
  const indices = keyParts.slice(1);
  
  // Traverse up the hierarchy by removing the last index at each level
  for (let level = indices.length - 1; level > 0; level--) {
    const parentIndices = indices.slice(0, level);
    let currentNode = translatedData;
    
    // Navigate to the parent node
    for (let i = 0; i < parentIndices.length; i++) {
      const index = parseInt(parentIndices[i]);
      if (Array.isArray(currentNode)) {
        currentNode = currentNode[index];
      } else if (currentNode?.children) {
        currentNode = currentNode.children[index];
      } else {
        break;
      }
    }
    
    // Check if this parent node is a loop
    if (currentNode && currentNode.ICON_DISPLAY === 'LOOP_ITEM') {
      parentLoops.push(currentNode);
    }
  }
  
  return parentLoops;
};

// Function to scroll to mapped nodes across tabs when double-clicking
export const scrollToMappedNode = (clickedNodeKey, mappings, automaticMappings, isSourceTree, currentTab) => {
  if (!clickedNodeKey) {
    return;
  }
  
  const allMappings = [...(mappings || []), ...(automaticMappings || [])];
  const tabMapping = ['header', 'body', 'trailer'];
  
  // Find mappings for the clicked node
  const relevantMappings = allMappings.filter(mapping => {
    if (isSourceTree) {
      return mapping.sourceKey === clickedNodeKey;
    } else {
      return mapping.targetKey === clickedNodeKey;
    }
  });

  if (relevantMappings.length === 0) {
    return;
  }

  // Find the topmost mapped node by checking actual DOM positions
  let bestMapping = relevantMappings[0];
  
  if (relevantMappings.length > 1) {
    // Multiple mappings found, need to find the topmost one
    if (isSourceTree) {
      // For source tree clicks, find the highest target node
      const targetContainer = document.getElementById('ob-tree');
      if (targetContainer) {
        let highestPosition = Infinity;
        
        for (const mapping of relevantMappings) {
          const targetElement = targetContainer.querySelector(`[data-key="${mapping.targetKey}"]`);
          if (targetElement) {
            const rect = targetElement.getBoundingClientRect();
            const containerRect = targetContainer.getBoundingClientRect();
            const relativeTop = rect.top - containerRect.top + targetContainer.scrollTop;
            
            if (relativeTop < highestPosition) {
              highestPosition = relativeTop;
              bestMapping = mapping;
            }
          }
        }
      }
    } else {
      // For target tree clicks, find the highest source node
      let highestPosition = Infinity;
      
      for (const mapping of relevantMappings) {
        const sourceTab = mapping.sourceTab !== undefined ? mapping.sourceTab : currentTab;
        const tabMapping = ['header', 'body', 'trailer'];
        const sourceContainerName = `mappingTree${tabMapping[sourceTab].charAt(0).toUpperCase() + tabMapping[sourceTab].slice(1)}`;
        const sourceContainer = document.getElementById(sourceContainerName);
        
        if (sourceContainer) {
          const sourceElement = sourceContainer.querySelector(`[data-key="${mapping.sourceKey}"]`);
          if (sourceElement) {
            const rect = sourceElement.getBoundingClientRect();
            const containerRect = sourceContainer.getBoundingClientRect();
            const relativeTop = rect.top - containerRect.top + sourceContainer.scrollTop;
            
            if (relativeTop < highestPosition) {
              highestPosition = relativeTop;
              bestMapping = mapping;
            }
          }
        }
      }
    }
  }

  // Use the best mapping (topmost node)
  const mapping = bestMapping;
  
  if (isSourceTree) {
    // Clicked on source tree, scroll to target tree
    const targetTab = mapping.targetTab !== undefined ? mapping.targetTab : currentTab;
    const targetTabName = tabMapping[targetTab];
    const targetKey = mapping.targetKey;
    
    if (!targetKey) {
      return;
    }
    
    // Switch to target tab if different and dispatch custom event
    if (targetTab !== currentTab) {
      // Create custom event to notify the target tree to switch tabs
      const event = new CustomEvent('scrollToMappedNode', { 
        detail: { 
          type: 'switchTargetTab',
          tab: targetTab, 
          targetKey: targetKey 
        } 
      });
      window.dispatchEvent(event);
    } else {
      // Same tab, just scroll to the target node
      setTimeout(() => {
        const targetContainer = document.getElementById('ob-tree');
        if (targetContainer) {
          const targetElement = targetContainer.querySelector(`[data-key="${targetKey}"]`);
          if (targetElement) {
            
            // Use scrollToSelectedItem utility for consistent scrolling
            const treeContainer = targetElement.closest('.overflow-auto');
            if (treeContainer) {
              try {
                scrollToSelectedItem([targetKey], { current: treeContainer });
              } catch (error) {
                // Fallback if scrollToSelectedItem fails
              }
              
              // Use a more direct and smooth scrolling approach
              setTimeout(() => {
                const elementRect = targetElement.getBoundingClientRect();
                const containerRect = treeContainer.getBoundingClientRect();
                const scrollTop = treeContainer.scrollTop;
                const targetScrollTop = scrollTop + (elementRect.top - containerRect.top) - 10; // 10px from top
                
                // Smooth scroll animation with improved easing
                const startTime = performance.now();
                const duration = 600; // Slightly longer for smoother feel
                const startScrollTop = treeContainer.scrollTop;
                const scrollDistance = targetScrollTop - startScrollTop;
                
                // Skip animation if distance is very small (reduces jitter)
                if (Math.abs(scrollDistance) < 5) {
                  treeContainer.scrollTop = targetScrollTop;
                  return;
                }
                
                function animateScroll(currentTime) {
                  const elapsed = currentTime - startTime;
                  const progress = Math.min(elapsed / duration, 1);
                  
                  // Improved easing function for smoother animation (ease-in-out)
                  const easeInOut = progress < 0.5 
                    ? 2 * progress * progress 
                    : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                  
                  treeContainer.scrollTop = startScrollTop + (scrollDistance * easeInOut);
                  
                  if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                  }
                }
                
                requestAnimationFrame(animateScroll);
              }, 16); // One frame delay to prevent jitter
            } else {
              targetElement.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start',
                inline: 'nearest'
              });
            }
            
            // Add highlight effect
            targetElement.style.backgroundColor = '#e6f7ff';
            targetElement.style.transition = 'background-color 0.3s ease';
            setTimeout(() => {
              targetElement.style.backgroundColor = '';
            }, 1500);
          }
        }
      }, 100);
    }
  } else {
    // Clicked on target tree, scroll to source tree
    const sourceTab = mapping.sourceTab !== undefined ? mapping.sourceTab : currentTab;
    const sourceTabName = tabMapping[sourceTab];
    const sourceKey = mapping.sourceKey;
    
    if (!sourceKey) return;
    
    // Switch to source tab if different and dispatch custom event
    if (sourceTab !== currentTab) {
      // Create custom event to notify the source tree to switch tabs
      const event = new CustomEvent('scrollToMappedNode', { 
        detail: { 
          type: 'switchSourceTab',
          tab: sourceTab, 
          sourceKey: sourceKey 
        } 
      });
      window.dispatchEvent(event);
    } else {
      // Same tab, just scroll to the source node
      setTimeout(() => {
        const sourceContainerName = `mappingTree${tabMapping[sourceTab].charAt(0).toUpperCase() + tabMapping[sourceTab].slice(1)}`;
        const sourceContainer = document.getElementById(sourceContainerName);
        if (sourceContainer) {
          const sourceElement = sourceContainer.querySelector(`[data-key="${sourceKey}"]`);
          if (sourceElement) {
            // Use scrollToSelectedItem utility for consistent scrolling
            try {
              scrollToSelectedItem([sourceKey], { current: sourceContainer });
            } catch (error) {
              // Fallback if scrollToSelectedItem fails
            }
            
            // Use a more direct and smooth scrolling approach for source
            setTimeout(() => {
              const elementRect = sourceElement.getBoundingClientRect();
              const containerRect = sourceContainer.getBoundingClientRect();
              const scrollTop = sourceContainer.scrollTop;
              const targetScrollTop = scrollTop + (elementRect.top - containerRect.top) - 10; // 10px from top
              
              // Smooth scroll animation with improved easing
              const startTime = performance.now();
              const duration = 600; // Slightly longer for smoother feel
              const startScrollTop = sourceContainer.scrollTop;
              const scrollDistance = targetScrollTop - startScrollTop;
              
              // Skip animation if distance is very small (reduces jitter)
              if (Math.abs(scrollDistance) < 5) {
                sourceContainer.scrollTop = targetScrollTop;
                return;
              }
              
              function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // Improved easing function for smoother animation (ease-in-out)
                const easeInOut = progress < 0.5 
                  ? 2 * progress * progress 
                  : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                
                sourceContainer.scrollTop = startScrollTop + (scrollDistance * easeInOut);
                
                if (progress < 1) {
                  requestAnimationFrame(animateScroll);
                }
              }
              
              requestAnimationFrame(animateScroll);
            }, 16); // One frame delay to prevent jitter
            
            // Add highlight effect
            sourceElement.style.backgroundColor = '#e6f7ff';
            sourceElement.style.transition = 'background-color 0.3s ease';
            setTimeout(() => {
              sourceElement.style.backgroundColor = '';
            }, 1500);
          }
        }
      }, 100);
    }
  }
}


// This function will prevent default event to happen when we press "Tab" or "Enter" in textfield
export const preventTabAndEnter = (e) => {
  const { value } = e.target;
  if (e.key === 'Tab') {
    e.preventDefault();
    e.stopPropagation();

    const cursorPosition = e.target.selectionStart;
    const cursorEndPosition = e.target.selectionEnd;
    const tab = '\t';

    e.target.value =
      value.substring(0, cursorPosition) +
      tab +
      value.substring(cursorEndPosition);

    // if you modify the value programmatically, the cursor is moved
    // to the end of the value, we need to reset it to the correct
    // position again
    e.target.selectionStart = cursorPosition + 1;
    e.target.selectionEnd = cursorPosition + 1;
  }
}

// stringifies an object, quotes all un-quoted attribute number/bool values, and returns a new JSON.parsed object.
// mainly used to cconvert int and bool to string.
// lkBool, if not true, will default convert bools capitalized - [true => "TRUE"], instead of [true => "true"].

/**
 * Sorts the keys of a JSON object or array recursively
 * @param {Object|Array} input - The input object or array to sort
 * @returns {Object|Array} - A new object or array with sorted keys
 */
export const sortJSONKeys = (input) => {
  // Create a recursive function to handle the sorting
  function recursiveSort(data) {
    // Return primitive values as is
    if (data === null || typeof data !== 'object') {
      return data;
    }
    
    // Handle arrays by recursively sorting each element
    if (Array.isArray(data)) {
      return data.map(item => recursiveSort(item));
    }
    
    // For objects, create a new object with sorted keys
    const sortedKeys = Object.keys(data).sort();
    const result = {};
    
    // Add each key in sorted order with recursively sorted values
    sortedKeys.forEach(key => {
      result[key] = recursiveSort(data[key]);
    });
    
    return result;
  }
  // const sortedObj = recursiveSort(input);
  // Call the recursive function with the input

  // return sortedObj;
  // Sorting should be done in the backend.
  return input;
}




export const stringifyJSONAttributes = (obj, lkBool) => {
  // Deep clone and clean the object: remove non-uppercase keys and keys with undefined/null values
  let cleaned = cloneDeep(obj);
  eachDeep(cleaned, (value, key, parent, context) => {
    if (
      parent &&
      typeof parent === 'object' &&
      !Array.isArray(parent) &&
      key !== undefined
    ) {
      // Remove keys that are not all uppercase
      if (typeof key === 'string' && (key !== key.toUpperCase() && !["useNTLMv1", "NTLMv2"].includes(key))) {
        delete parent[key];
        return false; // Don't go deeper
      }
      // Remove keys with undefined or null values
      if (value === undefined || value === null || value === t("SELECT") || value === t("EMPTY_COMBO") || value === '') {
        delete parent[key];
        return false;
      }
    }
  }, { leavesOnly: false, rootIsChildren: false });

  return JSON.parse(
    JSON.stringify(cleaned, (k, v) =>
      v && typeof v === 'object'
        ? v
        : !lkBool && v === true
          ? 'TRUE'
          : !lkBool && v === false
            ? 'FALSE'
            : '' + v
    )
  );
}

export function alphabetizeObj(obj) {
  if (typeof obj !== 'object') return obj; 
  if (Array.isArray(obj)) return obj.map(alphabetizeObj);

  const sortedObject = {};
  const keys = Object.keys(obj).sort();
  keys.forEach(key => sortedObject[key] = alphabetizeObj(obj[key]));
  return sortedObject;
}

export const stringToBooleanConversion = (str) => {
  if (str !== '') {
    if (str === 'TRUE') return true;
    else return false;
  } else return false;
}

// export const encryptPassword = (password, key) => {
//   const encrypted = CryptoJS.AES.encrypt(password, key).toString();
//   return encrypted;
// }

// function hexStringToByteArray(hexString) {
//   const byteArray = [];
//   for (let i = 0; i < hexString.length; i += 2) {
//     const hexByte = hexString.slice(i, i + 2);
//     const unsignedValue = parseInt(hexByte, 16);
//     const signedValue = (unsignedValue << 24) >> 24;
//     byteArray.push(signedValue);
//   }
//   return byteArray;
// }

// export const decryptPassword = (encryptedData, key) => {
//   const ciphertextBytes = CryptoJS.enc.Hex.parse(encryptedData);
//   // const ciphertextBytes = hexStringToByteArray(encryptedData);
//   console.log('Ciph', ciphertextBytes)

//   // Create a key from the provided string
//   const encoder = new TextEncoder();
//   const inputBytes = encoder.encode(key);
//   const resultBytes = new Uint8Array(16);
//   resultBytes.set(inputBytes.slice(0, 16))
//   console.log('Result Bytes', resultBytes)

//   // const decrypted = CryptoJS.AES.decrypt(
//   //   { ciphertext: ciphertextBytes },
//   //   resultBytes,
//   //   { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
//   // );
//   const decrypted = CryptoJS.AES.decrypt(
//     { ciphertext: CryptoJS.lib.WordArray.create(ciphertextBytes) },
//     resultBytes,
//     { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
//   );
//   console.log('Dec', decrypted)
//   // Convert the decrypted bytes to a UTF-8 string
//   const decryptedBase64 = CryptoJS.enc.Utf8.stringify(decrypted);
//   console.log('Decrypted Base64:', decryptedBase64);

//   const originalText = CryptoJS.enc.Utf8.stringify(decrypted);

//   return originalText;
// }
// console.log(decryptPassword('d764232fe344fc680a0f8be0a51a012c', 'admin'))


export const filterNodes = (data,tab)=> {
  // const newData = cloneDeep(tab !== 'body' ? (data[0]?.children || []) : (data || []))
  const newData = cloneDeep(data || [])
  const deepFilterFunction = (data) => {
    const filteredData =  data.filter((ele)=>{
      let bool = false;
      if(ele?.key && 
          (RECORD_TYPE[ele?.ICON_DISPLAY] || 
            FIELD_TYPE[ele?.ICON_DISPLAY] || 
            ele?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" ||
            ele?.ICON_DISPLAY === "RECORD_TOP"
          ) 
      ){
        bool=true;
      }

      if(bool && ele?.children){
        deepFilterFunction(ele?.children);
      }

      return bool;
      
    }) || []
    return filteredData;
  }
  deepFilterFunction(newData);
  return newData;

}

const getParentChain =  (encodedParentString) => {
  const parentsArray = encodedParentString?.split('%1E');
  parentsArray.pop();
  return parentsArray.join('%1E');
}

//filter certain node types from data. pass in arr of str to filter, ex: ["COMMENT", "QUERY"].
//returns an obj, ready to be used as treeData.
export const filterOutNodeTypes = (data, filterArr, source)=> {
  if (!data) return [];
  const dataClone = cloneDeep(data);
  const filterChildren = (fData, parentChain, parentName) => fData.filter(o => {
    if (filterArr.includes(o.type)) return false;
    else {
      o["PARENT"] = (FIELD_TYPE[o?.ICON_DISPLAY] || (o?.ICON_DISPLAY?.includes("ELEMENT") && !o?.children?.length)) ? getParentChain(parentChain) : parentChain;
      o.RECORD_TYPE = (FIELD_TYPE[o.ICON_DISPLAY] || (o?.ICON_DISPLAY?.includes("ELEMENT") && !o?.children?.length)) ? parentName : o?.TYPE || o?.ELEMENT_NAME;
      const newParentChain = o?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" ? parentChain : (parentChain + '%1E' + customEncoding(o?.TYPE || o?.ELEMENT_NAME || o?.MAPNAME));
      if (o.children) o.children = filterChildren(o.children, newParentChain, o?.TYPE || o?.ELEMENT_NAME || "NONE");
      return true;
    }
  });
  
  return filterChildren(dataClone, "NONE");
}

//filter data to only show certain node types. pass in arr of str, node types to show, ex: ["FIELD", "RECORD"].
//returns an obj, ready to be used as treeData.
export const filterInNodeTypes = (data, filterArr)=> {
  if (!data) return [];
  const dataClone = cloneDeep(data);
  const filterChildren = (fData) => fData.filter(o => {
    if (filterArr.includes(o.type)) {
      if (o.children) o.children = filterChildren(o.children);
      return true;
    } else {
      return false;
    }
  });
  
  return filterChildren(dataClone);
}

//simple debounce function. returns a clearTimeout, and 
//will execute callbackFunc if this func has not been run for 'timeMS' or 500ms default
export const debounceFunction = (callbackFunc, timeMS) => {
  const debounceTimout = setTimeout(() => {
    callbackFunc();
  }, timeMS || 500);

  return () => clearTimeout(debounceTimout);
}


export const getNodesByIcon = (data = [], iconsArray = []) => {
  const nodes = [];
  const loopNodes = (data) => {
    data?.forEach(e => {
      if (iconsArray.includes(e?.ICON_DISPLAY)) nodes.push(e);
      if(e?.children?.length) loopNodes(e.children);
    })
  }
  loopNodes(data);
  return nodes;
}

export const isValidJSON = (json) => {
  try {
    JSON.parse(json);
  }catch(err) {
    // JSON is malformed
    return false;
  }
  return true;
}
export const getParentKey = (key, treeData) => {
  let parentKey;
  for (let i = 0; i < treeData.length; i++) {
    const node = treeData[i];
    if (node.children) {
      // Check if any child of the current node has the given key
      const childNode = node.children.find((child) => child.key === key);
      if (childNode) {
        // If a child node with the given key is found, set the parent key
        parentKey = node.key;
      } else {
        // If not found, recursively search in the children
        const foundParent = getParentKey(key, node.children);
        // If a parent key is found in the children, return it
        if (foundParent) {
          return foundParent;
        }
      }
    }
  }
  return parentKey;
};
 export function filterNestedData(data, searchValue) {
  const result = [];

  function search(node, parent = null) {
    const newNode = { ...node, children: [] };
    let parentFound = false;
    if (node?.title?.toLowerCase().includes(searchValue.toLowerCase())) {
        if (parent) {
            result.forEach(existingNode => {
                if (existingNode.title === parent.title) {
                    existingNode.children.push(newNode);
                    parentFound = true;
                }
            });
            if (!parentFound) {
                const parentNode = { ...parent, children: [newNode] };
                result.push(parentNode);
            }
        } else {
            result.push(newNode);
        }
    }
    
    if (node.children) {
        node.children.forEach(child => {
            search(child, node);
        });
    }
}


  data.forEach(node => {
      search(node);
  });

  return result;
}

//fetch all data depots for account, and individually fetch their fields. return obj with callback function
export const getDataDepotObject = (queryParams, callback) => {
  let dataDepotObj = {};
  let fetchList = [];
  const requestUrl = `${queryParams.baseUrl}/workbench`;

  //1 - get initial data depot list
  const fetchDataDepotList = () => {
    const urlParams = {
      action: 'get_data_depot_list',
      user: queryParams.user,
      account: queryParams.account,
    }
    axios.get(requestUrl, {
      params: urlParams,
      headers: {
        "Authorization": `Bearer ${queryParams.token}`
      }
    }).then((response) => {
      if (response?.data?.data?.data_depot_list) {
        fetchList = response?.data?.data?.data_depot_list;
        return loopDDKeys(response?.data?.data?.data_depot_list)
      } else {
        return callback({});
      }
    }).catch((error) => {
      //dev log incase this needs to be tested and handled. Will be removed later.
      console.warn(error);
      return callback({});
    })
  }

  //2 - loop through array of strings, and request data depot field list fetch from each
  const loopDDKeys = (ddList) => {
    Object.entries(ddList).forEach((o, i) => {
      fetchDataDepotFields(o[0], o[1], i);
    });
    return;
  }

  //3 - fetch data depot field object
  const fetchDataDepotFields = (uid, ddName, i) => {
    const urlParams = {
      action: 'get_data_depot_field_list',
      user: queryParams.user,
      account: queryParams.account,
      data_depot_name: ddName
    }
    axios.get(requestUrl, {
      params: urlParams,
      headers: {
        "Authorization": `Bearer ${queryParams.token}`
      } 
    }).then((response) => {
      if (response?.data?.data?.data_field_list) setDDFields(uid, ddName, response?.data?.data?.data_field_list, i)
      else setDDFields(ddName, {}, i);
    }).catch((error) => {
      //dev log incase this needs to be tested and handled. Will be removed later.
      console.log(error);
      return setDDFields(ddName, {}, i);
    })
  }

  //4 - set data depot field list object for each data depot
  const setDDFields = (uid, ddName, fieldListObj, i) => {
    try {
      dataDepotObj = JSON.parse(JSON.stringify(dataDepotObj));
      dataDepotObj[uid] = {
        name: ddName,
        fieldList: fieldListObj
      };
      if (Object.keys(dataDepotObj).length === Object.keys(fetchList).length) callback(dataDepotObj);
    } catch (err) {
      console.warn("*** setDDFields error - debug details below ***")
      console.warn("err: ", err);
      console.warn("dataDepotObj: ", (dataDepotObj));
      console.warn("ddName: ", ddName);
      console.warn("fieldListObj: ", fieldListObj);
      console.warn(" ")
    }
    
  }

  fetchDataDepotList();
}
export function isParentFieldGroup(translatedData, selectedNode, parent = null) {
  function checkNode(node, parent) {
      if (node.key === selectedNode.key) {
          // Check if grandparent's ICON_DISPLAY is FIELD_GROUP
          return parent && (parent.ICON_DISPLAY === 'FIELD_GROUP' || parent.ICON_DISPLAY === 'REPEATING_FIELD_GROUP');
      }

      if (node.children && node.children.length > 0) {
          for (let child of node.children) {
              if (checkNode(child, node)) {
                  return true;
              }
          }
      }

      return false;
  }

  // Iterate through each top-level node
  for (let node of translatedData) {
      if (checkNode(node, null)) {
          return true;
      }
  }

  return false;
}

export function isGrandparentFieldGroup(translatedData, selectedNode) {
  function checkNode(node, parent, grandparent) {
      if (node.key === selectedNode.key) {
          // Check if grandparent's ICON_DISPLAY is FIELD_GROUP or REPEATING_FIELD_GROUP
          return grandparent && (grandparent.ICON_DISPLAY === 'FIELD_GROUP' || grandparent.ICON_DISPLAY === 'REPEATING_FIELD_GROUP');
      }

      if (node.children && node.children.length > 0) {
          for (let child of node.children) {
              if (checkNode(child, node, parent)) {
                  return true;
              }
          }
      }

      return false;
  }

  // Iterate through each top-level node
  for (let node of translatedData) {
      if (checkNode(node, null, null)) {
          return true;
      }
  }

  return false;
}
export function isParentRepeatingFieldGroup(translatedData, selectedNode, parent = null) {
  function checkNode(node, parent) {
      if (node.key === selectedNode.key) {
          // Check if grandparent's ICON_DISPLAY is FIELD_GROUP
          return parent && (parent.ICON_DISPLAY === 'REPEATING_FIELD_GROUP');
      }

      if (node.children && node.children.length > 0) {
          for (let child of node.children) {
              if (checkNode(child, node)) {
                  return true;
              }
          }
      }

      return false;
  }

  // Iterate through each top-level node
  for (let node of translatedData) {
      if (checkNode(node, null)) {
          return true;
      }
  }

  return false;
}
export function isParentRecordLoop(translatedData, selectedNode) {
  function checkNode(node, parent) {
      if (node?.key === selectedNode?.key) {
          return parent && (parent.ICON_DISPLAY === 'RECORD_LOOP');
      }

      if (node.children && node.children.length > 0) {
          for (let child of node.children) {
              if (checkNode(child, node)) {
                  return true;
              }
          }
      }

      return false;
  }

  // Iterate through each top-level node
  for (let node of translatedData) {
      if (checkNode(node, null)) {
          return true;
      }
  }

  return false;
}


export const decryption = (encryptedData) =>{
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  if (!encryptedData?.hasOwnProperty("PASSWORD")) return encryptedData;
  let  DecryptedData; 
 try {
  const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData.PASSWORD);
  // Extract IV from the beginning of the encrypted data
  const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4)); // First 16 bytes for IV
  const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4)); // Remaining bytes for ciphertext
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
   DecryptedData = decrypted.toString(CryptoJS.enc.Utf8);
} catch (error) {
  console.error(' Decryption failed:', error);
}
if(DecryptedData) return {...encryptedData,PASSWORD:DecryptedData};
else return encryptedData;
}

export const encryption = (body) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const encryptedPass = CryptoJS.AES.encrypt((body?.PASSWORD || body?.PASS_WORD || ''), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const ciphertext = iv.concat(encryptedPass.ciphertext).toString(CryptoJS.enc.Base64);
  if (body?.hasOwnProperty("PASSWORD")) {
      body["PASSWORD"] = ciphertext;
  }else if (body?.hasOwnProperty("PASS_WORD")) {
      body["PASS_WORD"] = ciphertext;
  }
  return body;
}



// Ensure key is exactly 24 bytes (Triple DES requirement)
const formatKey = (key) => {
    return CryptoJS.enc.Utf8.parse(key.substring(0, 24).padEnd(24, " ")); // Pad or truncate to 24 bytes
};

// Encrypt Function (Matches Java DESede)
export const encryptString = (plainText, secretKey) => {
    if (!plainText || !secretKey) return null;

    const key = formatKey(secretKey);
    const encrypted = CryptoJS.TripleDES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
        mode: CryptoJS.mode.ECB, // Java uses ECB mode by default
        padding: CryptoJS.pad.Pkcs7 // Java uses PKCS5Padding, which is PKCS7 in CryptoJS
    });

    return encrypted.toString(); // Java uses Base64 encoding, this matches it
};

// Decrypt Function (Matches Java DESede)
export const decryptString = (cipherText, secretKey) => {
    if (!cipherText || !secretKey) return null;
    
    // Check if the string is not encrypted
    try {
        // Try parsing as JSON or checking for Base64 format to determine if encrypted
        // If string doesn't cause error during decryption, assume it's encrypted
        const key = formatKey(secretKey);
        const decrypted = CryptoJS.TripleDES.decrypt(cipherText, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        
        const result = decrypted.toString(CryptoJS.enc.Utf8);
        
        // If decryption result is empty but input wasn't, it's likely not encrypted
        if (!result && cipherText) {
            return cipherText;
        }
        
        return result; // Return plaintext
    } catch (error) {
        console.error("Decryption failed:", error);
        // If decryption fails, the string is likely not encrypted, return original
        return cipherText;
    }
};







export function createThrottledFunction(func, delay, ...arg) {
  let hasTriggered = false;
  let lastCall = 0;

  return function() {
      const now = Date.now();
      lastCall = now;
      if (!hasTriggered || (now - lastCall) >= delay) {
          func(...arg);
          hasTriggered = true;
      } else {
          // console.log("Function has already been triggered or throttled.");
      }
  };
}

//console log with color. takes one log. obj/arr will be stringified.
//example: colorLog("#00FF00", "Hello World");
//         colorLog("red", {a: "123", b: 1, c: [1,2,3,'test', {a: "b"}]})
export function colorLog(color, log) {
  console.log(`%c${JSON.stringify(log)}`, `color: ${color}`);
}

function isURLEncoded(str) {
  try {
    return decodeURIComponent(str) !== str;
  } catch (e) {
    return false; // invalid sequence
  }
}

export const customEncoding = (value) => {
  const isEncoded = isURLEncoded(value);
  if (isEncoded) {
    return value;
  }
  
  if (!value?.length) return "";
  try {
    // Convert LF to CRLF to match Java behavior (Java URLEncoder expects CRLF line endings)
    // This ensures \n becomes \r\n before encoding
    let normalizedValue = value.replace(/\r?\n/g, '\r\n');
    
    // Use standard encodeURIComponent which encodes most characters
    let encoded = encodeURIComponent(normalizedValue);
    
    // Convert %20 to + to match Java URLEncoder behavior
    encoded = encoded.replace(/%20/g, '+');
    
    // Encode additional characters that Java URLEncoder encodes but encodeURIComponent doesn't
    // encodeURIComponent doesn't encode: - _ . ! ~ * ' ( )
    // Java URLEncoder only leaves unencoded: a-z A-Z 0-9 - _ . * (and space as +)
    // So we need to encode: ! ~ ' ( )
    encoded = encoded.replace(/!/g, '%21');   // Exclamation mark
    encoded = encoded.replace(/~/g, '%7E');   // Tilde
    encoded = encoded.replace(/'/g, '%27');   // Single quote/apostrophe
    encoded = encoded.replace(/\(/g, '%28');  // Opening parenthesis  
    encoded = encoded.replace(/\)/g, '%29');  // Closing parenthesis
    // Note: * (asterisk) is NOT encoded by Java URLEncoder, so we leave it as-is
    
    return encoded;
  } catch (err) {
    return value;
  }
}

export const customDecoding = (value) => {
  if (!value?.length) return "";
  try {
    // Replace + with space to match Java URLDecoder behavior (+ is encoded space)
    let decoded = value.replace(/\+/g, ' ');
    
    // Explicitly decode the characters we explicitly encoded (for symmetry and clarity)
    // These match the characters we encode in customEncoding
    decoded = decoded.replace(/%21/g, '!');   // Exclamation mark
    decoded = decoded.replace(/%7E/gi, '~');  // Tilde (case insensitive for %7e or %7E)
    decoded = decoded.replace(/%27/g, "'");   // Single quote/apostrophe
    decoded = decoded.replace(/%28/g, '(');   // Opening parenthesis
    decoded = decoded.replace(/%29/g, ')');   // Closing parenthesis
    
    // Use decodeURIComponent for remaining percent-encoded characters
    // This handles: %0D (CR), %0A (LF), and all other standard encoded characters
    let result = decodeURIComponent(decoded);
    
    // Keep CRLF as-is (don't convert back to LF) to maintain Java compatibility
    return result;
  } catch (err) {
    return value;
  }
}

/** SWT REPLACE strip segment ends with literal "%1F" before record separator. */
export const stripTrailingWorkflowFieldSep = (row) => {
  if (!row || typeof row !== "string") return row;
  return row.endsWith("%1F") ? row.slice(0, -3) : row;
};

/**
 * Canonical URL-encoding for workflow VARIABLE fields (REPLACE, MASK, SUBSTRING, etc.)
 * so Java WorkFlowTemplateMaintenance.ensureDecoded round-trips. Fixes mixed strings
 * (literal "[" with %-encoded separators) produced by some React copy/edit paths.
 */
export function normalizeWorkflowReplaceForPersistence(value) {
  if (value == null || value === "") return value;
  if (typeof value !== "string") return value;
  try {
    let decoded = value.replace(/\+/g, " ");
    decoded = decodeURIComponent(decoded);
    let encoded = encodeURIComponent(decoded).replace(/%20/g, "+");
    encoded = encoded
      .replace(/!/g, "%21")
      .replace(/~/g, "%7E")
      .replace(/'/g, "%27")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29");
    return encoded;
  } catch {
    return value;
  }
}

export function normalizeVariableActionEncodedFields(action) {
  if (!action || typeof action !== "object") return action;
  const out = { ...action };
  ["REPLACE", "REPLACEMENT", "MASK", "SUBSTRING"].forEach((k) => {
    if (out[k] != null && out[k] !== "") {
      out[k] = normalizeWorkflowReplaceForPersistence(String(out[k]));
    }
  });
  return out;
}

/** Walk workflow tree and normalize VARIABLE[] URL-sensitive fields (copy/paste, drag). */
export function normalizeWorkflowVariableEncodedFieldsDeep(data) {
  if (!Array.isArray(data)) return data;
  const walk = (nodes) => {
    nodes.forEach((node) => {
      if (node?.ICON_DISPLAY === "VARIABLE_ITEM" && Array.isArray(node.VARIABLE)) {
        node.VARIABLE = node.VARIABLE.map((va) => normalizeVariableActionEncodedFields(va));
      }
      if (node?.children?.length) walk(node.children);
    });
  };
  walk(data);
  return data;
}

//This function removes lowercase keys and undefined values from an object
export const removeLowerCaseAndUndefined = (obj) => {
  if (typeof obj !== 'object' || obj === null) return obj; // Handle non-objects

  return Object.keys(obj)
    .filter((key) => key.toLowerCase() !== key && obj[key] !== undefined) // Keep valid keys
    .reduce((acc, key) => {
      acc[key] = typeof obj[key] === 'object' ? removeLowerCaseAndUndefined(obj[key]) : obj[key];
      return acc;
    }, {});
};

// This function will return unique ID for new Workflow Items
export const getUniqueWorkflowItemId = (initialID,translatedData) => {
  const wfItems = translatedData?.children || [];
  let largestId = initialID || 0;

  for (let i = 0; i < wfItems.length; i++) {
     const item = wfItems[i];
     if ((item.hasOwnProperty('ID') && +item.ID > +largestId)) {
        largestId = item.ID;
        if(item.hasOwnProperty('OUTBOUND_ID') && +item.OUTBOUND_ID > +largestId){
          largestId = item.OUTBOUND_ID;
        }
     }
  }
  return +largestId + 1;
};

// New function: works recursively for array input, checking nested children as well
export const getUniqueWorkflowItemIdFromArrayOld = (translatedDataArray) => {
  let largestId = 0;

  const findLargestId = (items) => {
    if (!Array.isArray(items)) return;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item && typeof item === 'object') {
        if (item.hasOwnProperty('ID') && +item.ID > +largestId) {
          largestId = +item.ID;
        }
        if (item.hasOwnProperty('OUTBOUND_ID') && +item.OUTBOUND_ID > +largestId) {
          largestId = +item.OUTBOUND_ID;
        }
        if (Array.isArray(item.children)) {
          findLargestId(item.children);
        }
      }
    }
  };

  findLargestId(translatedDataArray);
  return largestId + 1;
};

export function getUniqueWorkflowItemIdFromArray(translatedData){
  if (!translatedData) return 1;
  
  const allIds = [];
  
  // Recursive function to search for all ID values in the data structure
  const findAllIds = (obj) => {
    if (obj && typeof obj === 'object') {
      // If current object has an ID, add it to our array
      if (obj.hasOwnProperty('ID')) {
        const id = parseInt(obj.ID);
        if (!isNaN(id)) {
          allIds.push(id);
        }
      }
      
      // Recursively search through all properties
      Object.values(obj).forEach(value => {
        if (Array.isArray(value)) {
          value.forEach(item => findAllIds(item));
        } else if (value && typeof value === 'object') {
          findAllIds(value);
        }
      });
    }
  };
  
  // Start the recursive search from translatedData
  findAllIds(translatedData);
  
  // Return the maximum ID + 1, or 1 if no IDs found
  return allIds.length > 0 ? Math.max(...allIds) + 1 : 1;
}


export const deepSearchAndEncode = (obj, keysArray, allowedItems = {}, callBackForEachNode) => {
  if (obj === null || obj === undefined) return obj; // Handle null or undefined values
  const clonedObj = cloneDeep(obj); // Create a deep clone of the object

  const processItem = (item, iconDisplay) => {
    if (item === null || item === undefined) return item;
    
    if (Array.isArray(item)) {
      // Process arrays
      for (let i = 0; i < item.length; i++) {
        item[i] = processItem(item[i], (item?.ICON_DISPLAY || iconDisplay));
      }
      return item;
    } else if (typeof item === 'object') {
      // Process objects
      for (const key in item) {
        if (keysArray?.includes(key) && allowedItems[key] && !allowedItems[key]?.includes(item?.ICON_DISPLAY || iconDisplay) || key == "SERVICE") {
          // Skip encoding for these keys
          continue;
        }
        else if (keysArray?.includes(key) && typeof item[key] === 'string') {
          item[key] = customEncoding(item[key]);
        } else {
          item[key] = processItem(item[key], (item?.ICON_DISPLAY || iconDisplay));
        }
      }
      return callBackForEachNode ? callBackForEachNode(item) : item;
    }
    
    return item;
  };

  return processItem(clonedObj, "");
};

export const deepSearchAndDecode = (obj, keysArray, allowedItems = {}) => {
  if (obj === null || obj === undefined) return obj; // Handle null or undefined values
  
  const clonedObj = cloneDeep(obj); // Create a deep clone of the object
  
  const processItem = (item , iconDisplay) => {
    if (item === null || item === undefined) return item;
    
    if (Array.isArray(item)) {
      // Process arrays
      for (let i = 0; i < item.length; i++) {
        item[i] = processItem(item[i] , (item?.ICON_DISPLAY || iconDisplay));
      }
      return item;
    } else if (typeof item === 'object') {
      // Process objects
      for (const key in item) {
        if (keysArray?.includes(key) && allowedItems[key] && !allowedItems[key]?.includes(item?.ICON_DISPLAY || iconDisplay) || key == "SERVICE") {
          // Skip encoding for these keys
          continue;
        }
        else if (keysArray.includes(key) && typeof item[key] === 'string') {
          item[key] = customDecoding(item[key]);
        } else {
          item[key] = processItem(cloneDeep(item[key]) , (item?.ICON_DISPLAY || iconDisplay));
        }
      }
      return item;
    }
    
    return item;
  };

  return processItem(clonedObj , "");
};


export const isParentKeyValueTrueNested = (keyName, expectedValue, translatedData, selectedNode) => {
  if (!selectedNode || !selectedNode.key || !translatedData) return false;

  const keyParts = selectedNode.key.split('-');
  if (keyParts.length < 2) return false; // Not a valid nested key

  // Remove the prefix (ib, ob, wf, etc)
  const indices = keyParts.slice(1).map(Number);
  indices.pop();
  const prefix = keyParts[0];
  
  let current = translatedData;
  if (!Array.isArray(current)) return false;
  for (let i = 0; i < indices.length; i++) {
    const idx = indices[i];
    if (!Array.isArray(current) || idx >= current.length) return false;
    current = current[idx];
    if (!current) return false;
    if (current[keyName] === expectedValue) return true;
    // If not last, try to find the next nested array (children)
    // Try common children keys
    if (i < indices.length - 1) {
      if (Array.isArray(current.children)) {
        current = current.children;
      } else if (Array.isArray(current.fields)) {
        current = current.fields;
      } else if (Array.isArray(current.nodes)) {
        current = current.nodes;
      } else {
        // Try to find the first array property
        const arrKey = Object.keys(current).find(k => Array.isArray(current[k]));
        if (arrKey) {
          current = current[arrKey];
        } else {
          return false;
        }
      }
    }
  }
  return false;

}


export const isUniqueItemName = (newName, translatedData, selectedNodeKey) => {
  let isUnique = true;
  eachDeep(translatedData, (item) => {
    if (item?.key && item?.key !== selectedNodeKey) {
      // For ELSE nodes, check ELSE_NAME property, for others check NAME property
      let itemName;
      if (item?.ICON_DISPLAY === "CONDITION_ELSE") {
        itemName = item?.ELSE_NAME;
      } else {
        itemName = item?.NAME;
      }
      
      if (itemName === newName) {
        isUnique = false;
        return false;
      }
    }
  });
  return isUnique;
}


export const validateWorkflowItemName = (newName, oldName, workflowData, currentItemKey, itemType) => {
  const trimmedNewName = newName?.trim() || '';
  const trimmedOldName = oldName?.trim() || '';
  
  // Workflow items that DON'T use name validation 
  const itemsWithoutValidation = ['VARIABLE_ITEM', 'SCHEDULE_WORKFLOW', 'TRACKING_REPORT_ITEM'];
  
  if (itemType && itemsWithoutValidation.includes(itemType)) {
    return {
      isValid: true,
      shouldRevert: false,
      errorMessage: null
    };
  }
  
  // Return error if name is null, empty, or unchanged
  if (!trimmedNewName || trimmedNewName === trimmedOldName) {
    return {
      isValid: false,
      shouldRevert: true,
      errorMessage: null
    };
  }
  
  // Check for duplicate names
  const isUnique = isUniqueItemName(trimmedNewName, workflowData, currentItemKey);
  
  if (!isUnique) {
    return {
      isValid: false,
      shouldRevert: true,
      errorMessage: 'BOX_WFITEM_NAMES_MUST_BE_UNIQUE'
    };
  }
  
  return {
    isValid: true,
    shouldRevert: false,
    errorMessage: null
  };
}

export const createWorkflowItemNameValidator = (
  setNameCallback,
  getWorkflowDataCallback,
  getCurrentItemKeyCallback,
  getItemTypeCallback,
  showErrorCallback = console.error
) => {
  return (newName, oldName) => {
    const workflowData = getWorkflowDataCallback();
    const currentItemKey = getCurrentItemKeyCallback();
    const itemType = getItemTypeCallback ? getItemTypeCallback() : null;
    
    const validationResult = validateWorkflowItemName(
      newName,
      oldName,
      workflowData,
      currentItemKey,
      itemType
    );
    
    if (validationResult.isValid) {
      setNameCallback(newName.trim());
      return true;
    } else {
      if (validationResult.errorMessage) {
        showErrorCallback(validationResult.errorMessage);
      }
      
      if (validationResult.shouldRevert) {
        setNameCallback(oldName?.trim() || '');
      }
      
      return false;
    }
  };
}


export const deepSetValueLogWFItemDetails = (data = [], value) => {
  if (!data) return;
  return data.map(e => {
    if (!["COMMENT", "CONDITION_ELSE"].includes(e?.ICON_DISPLAY)) {
      e["LOG_WFITEM_DETAILS"] = value;
    }
    if (e?.children) {
      e["children"] = deepSetValueLogWFItemDetails(e?.children, value);
    }
    return e;
  });
}

export const getSelectedNodeWhileCreation = (node = {}, translatedData = [], isInside = false) => {
  const selectedNodes = getSelectedNodes([node?.key], translatedData, true) || {};
  console.log(selectedNodes)
  if (isInside) return selectedNodes[0] || {};
  else return selectedNodes?.[1] || selectedNodes?.[0] || {};
}
